import styled from 'styled-components';

export const StyledCustomBanner = styled.div<{ isClose: boolean; maxHeight: string }>`
  transition: all 0.5s;
  overflow-y: hidden;
  max-width: 100%;
  padding-bottom: ${({ isClose }) => (isClose ? '0' : '1rem')};
  max-height: ${({ isClose, maxHeight }) => (isClose ? '0' : maxHeight)};
`;
